import { useFormik, Form, FormikProvider } from "formik";
import { Button } from "styled";
import InputField from "components/formik/InputField";
import Model from "components/Modal";
import { createDocument, getAllData } from "apis/customApiHandler";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import Select from "react-select";
import { useLocation } from "react-router-dom";
import { saveErrorCreationEvent } from "utils/analytics";
import { ANALYTICS_EVENTS } from "utils/analyticsEvents";

const AddPermissions = ({ handleClick }) => {
  let disabled = false;
  const queryClient = useQueryClient();
  const location = useLocation();

  function roleCreationEventFunc(eventName, modelName, params) {
    return saveErrorCreationEvent(eventName, modelName, "Roles & Permissions", location.pathname, params);
  }
  const {
    data: { data: permissions },
  } = useQuery(["permissions"], () =>
    getAllData("/permissions", {
      // limit: 120,
      // page: 1,
    })
  );

  const formik = useFormik({
    initialValues: {
      name: "",
      permissions: [],
    },
    onSubmit: async (values) => {
      const eventParams = {
        role_name: values.name,
        permissions: permissions?.filter((p) => values.permissions.includes(p._id))?.map((p) => p.name),
      };
      try {
        roleCreationEventFunc(ANALYTICS_EVENTS.CLICK_SAVE_CHANGES, "Add Role", eventParams);
        const data = await createDocument("roles", values);
        if (data && data.data) {
          roleCreationEventFunc(ANALYTICS_EVENTS.SYS_ADD_ROLE_SUCCESS, "Add Role", eventParams);
          toast.success("Successfully Saved");
        }
        queryClient.invalidateQueries("roles");
        handleClick();
      } catch (error) {
        const errMsg = error?.response?.data?.message || error?.message;
        roleCreationEventFunc(ANALYTICS_EVENTS.SYS_ADD_ROLE_ERROR, "Add Role", { errMsg });
      }
    },

    validate: (values) => {
      let errors = {};
      if (!values.name) errors.name = "Required";
      if (!values.permissions.length) errors.permissions = "Required";
      return errors;
    },
  });

return (
  <Model
    handleClick={handleClick}
    title={`Add User Role & Permissions`}
    className="w-full max-w-2xl h-max"
  >
    <FormikProvider value={formik} className=" overflow-scroll">
      <Form className="px-5 text-gray-700 overflow-y-visible font-medium text-base grid lg:gap-x-14 gap-y-5 grid-flow-row grid-cols-1 lg:grid-cols-2 w-full h-full">
        <InputField type="text" label="User Role Name" name="name" />
        <br />
        <div className=" border-2 p-2 my-2 col-span-2 flex flex-col justify-center items-start gap-0 text-gray-600 font-normal">
          <label className="py-3">
            Select Permissions
            <Select
              styles={{
                control: (styles) => ({
                  ...styles,
                  backgroundColor: "white",
                  minWidth: '500px',
                  // ? "white"
                  // : "#FF9193F",
                  // position: "relative",
                }),
                menuPortal: (styles) => ({
                  ...styles,
                  zIndex: 9999,
                  fontWeight: "500",
                  fontSize: "14px",
                  lineHeight: "1.25rem" /* 20px */,
                }),
                menu: (styles) => {
                  return {
                    ...styles,
                    // positlion: "absolute",
                    opacity: 1,
                    // transform: "none",
                    // minWidth: "120px",
                    // transition: "opacity 251ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 167ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                    // top: "0",
                    // left: "0",
                    // zIndex: 10,
                    // overflow: "visible"
                    // transformOrigin: "60px 0px",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  const color = data.color;
                  return {
                    ...styles,
                    fontWeight: "400",
                    zIndex: 1000, // You can adjust the zIndex value as needed
                  };
                },
                input: (styles) => ({ ...styles }),
                placeholder: (styles) => ({ ...styles, fontWeight: "400" }),
                singleValue: (styles, { data }) => ({ ...styles }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={permissions?.map((permission) => {
                return {
                  value: permission._id,
                  label: permission.name,
                };
              })}
              value={
                formik.values.permissions &&
                formik.values.permissions?.map((permission) => {
                  return {
                    value: permission,
                    label: permissions.find((perm) => perm._id === permission)
                      ?.name,
                  };
                })
              }
              onChange={(value) => {
                formik.setFieldValue(
                  "permissions",
                  value.map((permission) => permission.value)
                );
              }}
              name="permissions"
              isMulti={true}
            />
            {formik.touched.permissions && formik.errors.permissions ? (
              <p className="text-red-500 font-normal">
                *{formik.errors.permissions}
              </p>
            ) : null}
          </label>
        </div>
      </Form>
      <div className="px-5 flex justify-end items-center gap-4 pb-8 flex-wrap sm:w-full">
        <Button bgSecondary onClick={handleClick}>
          Cancel
        </Button>
        <Button type="button" bgPrimary onClick={formik.handleSubmit}>
          Save Changes
        </Button>
      </div>
    </FormikProvider>
  </Model>
);
};

export default AddPermissions;
